import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Providers } from "./providers";
import { useFeatureGate } from "./hooks";
import packageJSON from "../package.json";

// Import pages
import ArtList from "./pages/art/index";
import InProgressArtList from "./pages/art-in-progress";
import ArtDetail from "./pages/art/[slug]";
import Cart from "./pages/cart/index";
import Checkout from "./pages/cart/checkout";
import OrderList from "./pages/order/index";
import OrderDetail from "./pages/order/[slug]/index";
import AdminArtList from "./pages/admin/art/index";
import AdminArtEdit from "./pages/admin/art/[slug]";
import AdminOrderList from "./pages/admin/order/index";
import AdminOrderDetail from "./pages/admin/order/[slug]/index";
import AdminShipmentEdit from "./pages/admin/shipment/[slug]";
import Auth from "./pages/user/[slug]";
import NotFound from "./pages/404";
import PolicyPage from "./pages/policy/[slug]";
import PublicShipmentPage from "./pages/shipment/[slug]";
import AcceptDevSite from "./pages/accept-dev-site";
import Home from "./pages/index";
import CheckoutSuccess from "./pages/cart/checkout-success";

function App() {
  // Version logging
  useEffect(() => {
    console.log("welcome to V" + packageJSON.version);
  }, []);

  // Initialize feature gates
  useFeatureGate();

  return (
    <Providers>
      <Routes>
        {/* Home page */}
        <Route path="/" element={<Home />} />

        {/* Art routes */}
        <Route path="/art" element={<ArtList />} />
        <Route path="/art-in-progress" element={<InProgressArtList />} />
        <Route path="/art/:slug" element={<ArtDetail />} />

        {/* TODO: use multiple entry points in vite.config for a seperate checkout section (so stripe doesn't load on every page?)  */}
        {/* Cart & Checkout routes */}
        <Route path="/cart" element={<Cart />} />
        <Route path="/cart/checkout" element={<Checkout />} />
        <Route path="/cart/checkout/:checkoutId" element={<Checkout />} />
        <Route
          path="/cart/checkout/:checkoutId/success"
          element={<CheckoutSuccess />}
        />

        {/* Order routes */}
        <Route path="/order" element={<OrderList />} />
        <Route path="/order/:slug" element={<OrderDetail />} />

        {/* Admin routes */}
        <Route path="/admin/art" element={<AdminArtList />} />
        <Route path="/admin/art/:slug" element={<AdminArtEdit />} />
        <Route path="/admin/order" element={<AdminOrderList />} />
        <Route path="/admin/order/:slug" element={<AdminOrderDetail />} />
        <Route path="/admin/shipment/:slug" element={<AdminShipmentEdit />} />

        {/* Auth routes */}
        <Route path="/user/:slug" element={<Auth />} />

        {/* Utility routes */}
        <Route path="/policy/:slug" element={<PolicyPage />} />
        <Route path="/shipment/:slug" element={<PublicShipmentPage />} />
        <Route path="/accept-dev-site" element={<AcceptDevSite />} />
        <Route path="/404" element={<NotFound />} />

        {/* 404 catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Providers>
  );
}

export default App;
